import axios from 'axios';
import { API_URL } from '../config';

const FARMER_MAPPING_URL = `${API_URL}/mappings`;

export const farmerMappingService = {
    // Get all mappings with optional filters
    getAllMappings: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.farmer) params.append('farmer', filters.farmer);
        if (filters.company) params.append('company', filters.company);
        if (filters.status) params.append('status', filters.status);

        const response = await axios.get(FARMER_MAPPING_URL, { params });
        return response.data;
    },

    // Get a single mapping by ID
    getMapping: async (id) => {
        const response = await axios.get(`${FARMER_MAPPING_URL}/${id}/`);
        return response.data;
    },

    // Create a new mapping
    createMapping: async (mappingData) => {
        const response = await axios.post(FARMER_MAPPING_URL, mappingData);
        return response.data;
    },

    // Create multiple mappings at once
    bulkCreateMappings: async (mappingsData) => {
        const response = await axios.post(`${FARMER_MAPPING_URL}/bulk_create/`, mappingsData);
        return response.data;
    },

    // Update a mapping
    updateMapping: async (id, mappingData) => {
        const response = await axios.put(`${FARMER_MAPPING_URL}/${id}/`, mappingData);
        return response.data;
    },

    // Update mapping status
    updateMappingStatus: async (id, statusData) => {
        const response = await axios.post(`${FARMER_MAPPING_URL}/${id}/update_status/`, statusData);
        return response.data;
    },

    // Delete a mapping
    deleteMapping: async (id) => {
        await axios.delete(`${FARMER_MAPPING_URL}/${id}/`);
    }
}; 